export default __webpack_public_path__ + "static/media/pdf.c5e0d1aa.svg";